
const defaultAttrs = {"width":"1024","height":"1024","version":"1.1","viewBox":"0 0 1024 1024"};
const svgInner = "<path fill=\"currentColor\" d=\"M766.701 84.07c47.846-47.843 125.414-47.843 173.254 0s47.84 125.412 0 173.255L534.621 662.656a32 32 0 0 1-14.865 8.416l-170.667 42.669c-23.436 5.856-44.665-15.366-38.806-38.803L352.95 504.27a32 32 0 0 1 8.417-14.865zM495.636 611.137 894.7 212.07c22.848-22.849 22.848-59.896 0-82.745s-59.891-22.85-82.746 0L412.888 528.389l-27.581 110.328zm-324.974-472.44h298.666c17.673 0 32 14.327 32 32s-14.327 32-32 32H170.662c-29.455 0-53.334 23.878-53.334 53.334v597.332c0 29.459 23.878 53.331 53.334 53.331h597.332c29.459 0 53.338-23.872 53.338-53.331V554.697c0-17.672 14.323-32 32-32 17.67 0 32 14.328 32 32v298.666c0 64.8-52.531 117.331-117.338 117.331H170.662c-64.801 0-117.334-52.531-117.334-117.331V256.031c0-64.802 52.532-117.334 117.334-117.334\"/>";

export default function EditSvg(props = {}) {
  const className = props.className || props.class;
  const viewBox = defaultAttrs.viewBox;

  let attrs = 'xmlns="http://www.w3.org/2000/svg"';
  if (viewBox) attrs += ' viewBox="' + viewBox + '"';
  if (className) attrs += ' class="' + className + '"';
  if (props.width !== undefined) attrs += ' width="' + props.width + '"';
  if (props.height !== undefined) attrs += ' height="' + props.height + '"';

  return '<svg ' + attrs + '>' + svgInner + '</svg>';
}
